<div class="main-content">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-md-12">
        <span class="pull-left">
          <h2 class="text-purple-manax m-0 pl-3 title-section">Reporte Marcaciones</h2>
          <p class="d-none d-sm-inline text-purple-manax pl-3 subtitle-section">Listado total de horas por trabajador
          </p>
        </span>
        <span class="pull-right pt-1 pb-4">
          <button (click)="openHelpVideoModal()" class="btn btn-outline-manax p-2 ml-2 pull-right">
            <i class="material-icons align-middle">play_circle</i>&nbsp;<span class="d-none d-sm-inline">Tutorial</span>
          </button>
        </span>
        <br><br>
        <br><br>

        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <span class="pull-left text-purple-manax subtitle-section mr-2 mt-2">Fecha:</span>
              <span class="pull-left mr-2">
                <input type="date" class="filter small" [(ngModel)]="selectedDayStart"
                  (ngModelChange)="selectedDayChange()" (click)="$event.stopPropagation()" [max]="maxDate"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 120px; margin-top:9px" />
              </span>
              <span class="text-purple-manax pull-left subtitle-section mr-2 mt-2">&nbsp;a&nbsp;</span>
              <span class="pull-left mr-2">
                <input type="date" class="filter small" [(ngModel)]="selectedDayEnd"
                  (ngModelChange)="selectedDayChange()" (click)="$event.stopPropagation()" [max]="maxDate"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 120px; margin-top:9px" />
              </span>
              <span class="pull-left mr-2">
                <mat-form-field appearance="outline">
                  <mat-label>Categorías</mat-label>
                  <mat-select name="categories" [(ngModel)]="categoriesFilter" (ngModelChange)="onChangeCategories()"
                    multiple>
                    <mat-option *ngFor="let cat of categories" [value]="cat._id">{{cat.name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </span>

              <span class="pull-right">
                <button class="btn btn-manax" (click)="exportReport()">
                  <i class="material-icons">download</i> Descargar
                </button>
              </span>
            </div>
          </div>
        </div>

        <!-- <div class="table-striped"> -->
        <table class="table table-hover m-0 align-top" matSort (matSortChange)="sortTimeTracks($event)" stickyHeader
          stickyFooter>

          <thead class="text-manax">
            <tr>

              <!-- PC -->
              <th class="d-none d-md-table-cell align-top col-md-3 ms-md-auto">
                Trabajador<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.worker"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 1000px;" />
              </th>

              <th class="d-none d-md-table-cell align-top">
                Horas programadas
              </th>

              <th class="d-none d-md-table-cell align-top">
                Horas trabajadas
              </th>

              <th class="d-none d-md-table-cell align-top">
                Horas de descanso
              </th>

              <th>
                
              </th>

              <!-- Mobile -->
              <th class="d-table-cell d-md-none">
                Orden por: <span class="ml-2">{{sortOptions[filter.sort] || 'ninguno'}}</span>
                <span class="text-manax pull-right cursor-pointer" *ngIf="filtered"> - Filtrada - </span>
              </th>

              <!-- All -->
              <th class="td-actions text-right p-0">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">

                  <!-- sort order -->
                  <button mat-menu-item class="d-block d-md-none" [matMenuTriggerFor]="order">
                    <span>Orden</span>
                  </button>

                  <!-- filters -->
                  <!--button mat-menu-item class="d-block d-md-none" (click)="openFilter()">
                            <span>Filtros</span>
                          </button-->
                  <button mat-menu-item (click)="clearFilter()">
                    <span>Limpiar Filtros</span>
                  </button>
                  <button mat-menu-item (click)="exportReport()">
                    <span>Exportar Listado</span>
                  </button>
                </mat-menu>

                <mat-menu #order="matMenu">
                  <ng-container *ngFor="let key of sortOptionsKeys">
                    <button mat-menu-item (click)="sortTimeTracks(key)">
                      <span>{{sortOptions[key]}}</span>
                    </button>
                  </ng-container>
                  <button mat-menu-item (click)="sortTimeTracks('')">
                    <span>Sin Ordenar</span>
                  </button>
                </mat-menu>
              </th>
            </tr>
          </thead>

          <tbody>
            <!-- default: future tasks, past or current with tracking ok -->
            <!-- primary: past with tracking null or delayed, or current with tracking delayed -->
            <!-- danger: current with tracking null -->
            <ng-container *ngFor="let timeTrack of timeTracks">

              <tr>

                <!-- PC -->
                <td class="d-none d-md-table-cell field-container">
                  {{timeTrack.worker}}
                </td>
                <td class="d-none d-md-table-cell field-container">
                  {{timeTrack.totalscheduled}}
                </td>
                <td class="d-none d-md-table-cell field-container">
                  {{timeTrack.totalrealworked}}
                </td>
                <td class="d-none d-md-table-cell field-container">
                  {{timeTrack.totalbreak}}
                </td>
                <!--
                <td class="d-none d-md-table-cell field-container">
                  {{totalworked}}
                </td>
                -->
                
                <td class="d-none d-md-table-cell field-container">
                  <button class="btn btn-link text-manax text-capitalize p-0 text-left"
                    (click)='details(timeTrack.workerId)'>Ver detalle</button>
                </td>
                
                <!-- Mobile -->
                <td class="d-table-cell d-md-none" style="line-height: 14px;">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-4">
                        <div class="row mb-2 pr-3">
                          <b class="bold-item">
                            {{timeTrack.worker}}
                          </b>
                        </div>
                        <div class="row mb-2 pr-3">
                          Total Hs Trabajado: {{timeTrack.totalbreak}}
                        </div>
                      </div>
                      <!--
                      <div class="col-4 d-flex flex-column align-items-center justify-content-center p-0">
                        <div class="row px-3">
                          Horas RESUME: {{this._UtilsService.convertMsToHM(timeTrack.totalRESUME)}}
                        </div>
                      </div>
                      -->
                      <div class="col-4 d-flex flex-column align-items-center justify-content-center p-0">
                        <div class="row px-3">
                          Total Hs Descanso: {{timeTrack.totalrealworked}}
                        </div>
                      </div>
                      
                      <div class="col-4 d-flex flex-column align-items-center justify-content-center p-0">
                        <div class="row pl-3">
                          <button mat-button type="button" class="btn btn-manax btn-link p-0 m-0 inline-icon"
                            (click)='details(timeTrack.workerId)'
                            style="border: 1px solid #4B39EF; padding: .2px 5px !important;">
                            Ver detalle
                          </button>
                        </div>
                      </div>

                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>

            <!-- All -->
            <tr *ngIf="thereAreMore && !loading">
              <td colspan="10">
                <button class="btn btn-link text-manax text-capitalize p-0" (click)='loadMore()'>+ cargar
                  mas</button>
              </td>
            </tr>
            <tr *ngIf="loading">
              <td colspan="10" class="text-center">
                <div class="d-flex justify-content-center">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot class="text-manax" *ngIf="!loading">
            <tr>
              <td colspan="10">
                <div class="row">
                  <div class="col-md-6 text-md-right">
                    Mostrando: {{ timeTracks.length }} resultados
                  </div>
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
        <!-- </div> -->
      </div>
    </div>
    <div class="row" *ngIf="totalMoreMinTutorial && !loading">
      <div class="col-12 video-responsive">
        <iframe [src]="safeSrc" title="YouTube video player" frameborder="0"
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen></iframe>
      </div>
    </div>
  </div>
</div>